import React from 'react';
import { Input, Button } from 'reactstrap';
import { Controller } from 'react-hook-form';
import { FaPlus, FaTrash } from 'react-icons/fa';

import { MatrixTable, MatrixSLAContainer } from '../form/styled';

const MatrixSLATable = ({
  columnFields,
  control,
  id,
  appendColumn,
  removeColumn,
  rowFields,
  appendRow,
  removeRow,
  setValue,
  defaultValuesSLA
}) => {
  return (
    <MatrixSLAContainer className="tour3-dt">
      <MatrixTable>
        <thead>
          <tr>
            <th>
              <div className="tour4-dt">
                <label>Criticidade</label> / <br />
                <label>Impactos</label>
              </div>
            </th>
            {columnFields.map((column, columnIndex) => (
              <th key={column.id}>
                <div className="sla_fields_description">
                  <Controller
                    as={<Input />}
                    control={control}
                    name={`columns[${columnIndex}].name`}
                    defaultValue={column.name || ''}
                  />
                  <div className="tour7-dt sla_fields_input_description">
                    <label>SLA Atendimento</label>
                    <label>SLA Solução</label>
                  </div>
                </div>
              </th>
            ))}
            <th className="tour5-dt sla_columns_actions_wrapper">
              {columnFields.length < 6 && (
                <Button
                  color="success"
                  size="sm"
                  disabled={id ? true : false}
                  onClick={appendColumn}
                >
                  <FaPlus size={12} />
                </Button>
              )}
              {columnFields.length > 1 && (
                <Button
                  color="danger"
                  size="sm"
                  disabled={id || columnFields.length < 1 ? true : false}
                  onClick={() => removeColumn(columnFields.length - 1)}
                >
                  <FaTrash size={12} />
                </Button>
              )}
            </th>
          </tr>
        </thead>
        <tbody>
          {rowFields.map((row, rowIndex) => (
            <tr key={row.id} className="tour4-dt">
              <td>
                <Controller
                  as={
                    <Input
                      style={{ width: 'fit-content', marginBottom: '0.25rem' }}
                    />
                  }
                  control={control}
                  name={`rows[${rowIndex}].name`}
                  defaultValue={row.name || ''}
                />
              </td>
              {columnFields.map((column, columnIndex) => (
                <td key={column.id}>
                  <div className="tour8-dt sla_input_wrapper_all">
                    <div className="sla-input-wrapper">
                      <Controller
                        control={control}
                        as={<Input type="number" min="0" />}
                        setValue={setValue}
                        name={`sla_service[${rowIndex}][${columnIndex}]`}
                        disabled={id ? true : false}
                        defaultValue={
                          defaultValuesSLA?.[
                            `sla_service[${rowIndex}][${columnIndex}]`
                          ] ?? ''
                        }
                      />
                    </div>
                    <div className="sla-input-wrapper">
                      <Controller
                        as={<Input type="number" min="0" />}
                        setValue={setValue}
                        control={control}
                        disabled={id ? true : false}
                        name={`sla_solution[${rowIndex}][${columnIndex}]`}
                        defaultValue={
                          defaultValuesSLA?.[
                            `sla_service[${rowIndex}][${columnIndex}]`
                          ] ?? ''
                        }
                      />
                    </div>
                  </div>
                </td>
              ))}
            </tr>
          ))}
          <tr>
            <td className="tour6-dt sla_rows_actions_wrapper">
              {rowFields.length < 6 && (
                <Button
                  disabled={id ? true : false}
                  color="success"
                  size="sm"
                  onClick={appendRow}
                >
                  <FaPlus size={12} />
                </Button>
              )}
              {rowFields.length > 1 && (
                <Button
                  color="danger"
                  size="sm"
                  disabled={id || rowFields.length < 1 ? true : false}
                  onClick={() => removeRow(rowFields.length - 1)}
                >
                  <FaTrash size={12} />
                </Button>
              )}
            </td>
          </tr>
        </tbody>
      </MatrixTable>
    </MatrixSLAContainer>
  );
};

export default MatrixSLATable;
